import { render, staticRenderFns } from "./signServiceFee.vue?vue&type=template&id=747f8096"
import script from "./signServiceFee.vue?vue&type=script&lang=js"
export * from "./signServiceFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports